import React from 'react'

import styled from 'styled-components'

import { Box } from '@myxplor/stardust'

const FullHeightFlex = styled(props => <Box display="flex" {...props} />)`
  height: auto;
  min-height: 100vh;
`

const MaxWidthLayout = ({ children }) => (
  <FullHeightFlex width={1} justifyContent="center">
    <Box bg="white" padding="none" width={[1, 1, 1, '1660px']}>
      {children}
    </Box>
  </FullHeightFlex>
)

MaxWidthLayout.displayName = 'MaxWidthLayout'
export default MaxWidthLayout
